// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import {store} from './storage/storage'
import VueWait from 'vue-wait'
import { VueSpinners } from '@saeris/vue-spinners'



Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueWait)
Vue.use(VueSpinners)

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter) // or with custom config
Vue.use(VueCurrencyFilter,
  {
    symbol : '$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

//sync(store, router)

router.beforeEach((to, from, next) => {
  if (to.meta.admin && store.state.login.jwt == null) {
    next(false)
  } else {
    next()
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  wait: new VueWait({
    // Defaults values are following:
    useVuex: true,              // Uses Vuex to manage wait state
    //vuexModuleName: 'publicaciones',      // Vuex module name
  }),
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js